































































import { Vue, Component, Inject, Prop } from "vue-property-decorator";
import {
  IBrandsProvider,
  IBrandsProviderMethods
} from "@/models/providers/brands";
import { IBrand } from "@/models/brands";

@Component({
  components: {
    "brand-grid-item": () =>
      import("@/components/app/admin/settings/brands/brandGridItem.vue")
  }
})
export default class UpmindBrandsGrid extends Vue {
  // Inject

  @Inject({ from: "brandsProviderData" })
  public readonly $brandsProvider!: () => IBrandsProvider;

  @Inject({ from: "brandsProviderMethods" })
  public readonly $brandsMethods!: IBrandsProviderMethods;

  @Prop({ default: null })
  public readonly skeletonCount!: number;

  // Computed

  public get $brandsData() {
    return this.$brandsProvider();
  }

  public get skeletonSize() {
    return (
      this.$brandsData.table.total ||
      (this.skeletonCount ?? this.$store.getters["ui/isMobile"] ? 2 : 6)
    );
  }

  // Methods

  public goToDefaultDomain(brand: IBrand) {
    const defaultOauthClient = this.$_.find(
      brand?.oauth_clients || [],
      domain => domain.default
    )?.origin;

    const url = `${location.protocol}//${defaultOauthClient}${
      location.port ? `:${location.port}` : ""
    }`;
    window.open(url, "_blank");
  }
}
